import styled from 'styled-components';


const GrayImage = styled.div`
  mix-blend-mode: multiply;
  filter: grayscale(100%);
`;

export default GrayImage;
